/*
  Publishes "spill:waitlist_signup" when someone genuinely joins the Viral Loops
  waitlist, so the Shopify custom pixel can send Meta a Lead event.

  Why it works this way:
  - The Viral Loops form-widget draws into a shadow root, so there is no form
    element in the theme to listen on.
  - window.fbq does not exist on the page. The Meta pixel runs inside Shopify's
    web pixel sandbox, so the only way to reach it is Shopify.analytics.publish.
  - Viral Loops dispatches a window event on a real signup:
      VL:<ucid>:participation   detail = { user: {...} }
    Read from their loader.js on 2026-10-14. setUser(), which writes the
    "<ucid>#user" localStorage key, runs on every identify, including a
    returning participant re-entering their email and the ?userCode= auto
    login. The dispatch below is gated on the API's isNew flag, so it is the
    only signal that means "a new person just joined". Watching localStorage,
    which this file used to do, counted returning participants as new leads.
  - Failed participations dispatch the same event with detail.errors and no
    detail.user, so the guard below ignores them.
  - ?ri=1 makes Viral Loops re-dispatch for an existing participant. Ignored
    for the same reason.

  Privacy: Shopify custom events reach every pixel on the shop, not only ours,
  so the email never leaves this file in the clear. It is normalised and
  SHA-256 hashed here, and Meta takes the hash as an advanced matching value.

  Fires at most once per browser per campaign. The event id is derived from the
  hashed email, so the same person signing up in two tabs, two browsers or two
  devices produces one id, and Meta deduplicates the rest.
*/
(function () {
  if (window.spillWaitlistLeadEvent) return;
  window.spillWaitlistLeadEvent = true;

  var EVENT_NAME = 'spill:waitlist_signup';

  function read(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* private mode: the event still fires, it just may fire again later */
    }
  }

  function drop(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {}
  }

  function subtle() {
    if (!window.crypto || !window.crypto.subtle) return null;
    return window.crypto.subtle;
  }

  /* Meta's normalisation: trim, lowercase, then SHA-256 as lowercase hex */
  function hash(value) {
    var crypto = subtle();
    var clean = String(value == null ? '' : value).trim().toLowerCase();

    if (!clean || !crypto || typeof TextEncoder === 'undefined') {
      return Promise.resolve('');
    }

    return crypto.digest('SHA-256', new TextEncoder().encode(clean)).then(function (buffer) {
      var bytes = new Uint8Array(buffer);
      var out = '';
      for (var i = 0; i < bytes.length; i++) {
        out += (bytes[i] < 16 ? '0' : '') + bytes[i].toString(16);
      }
      return out;
    }).catch(function () {
      return '';
    });
  }

  function publish(payload) {
    if (!window.Shopify || !window.Shopify.analytics) return false;
    if (typeof window.Shopify.analytics.publish !== 'function') return false;

    window.Shopify.analytics.publish(EVENT_NAME, payload);
    console.info('[waitlist] ' + EVENT_NAME + ' published, event_id ' + payload.event_id);
    return true;
  }

  function reIdentify() {
    return /[?&]ri=1(&|$)/.test(window.location.search);
  }

  function onParticipation(ucid, doneKey, event) {
    var detail = event && event.detail;
    if (!detail || detail.errors || !detail.user) return;
    if (reIdentify()) return;
    if (read(doneKey)) return;

    var user = detail.user;
    var email = user.email;
    if (!email) return;

    Promise.all([hash(email), hash(user.firstname || user.firstName)]).then(function (hashed) {
      var emailHash = hashed[0];
      var nameHash = hashed[1];
      if (!emailHash) return;

      var id = 'wl-' + emailHash.slice(0, 16);
      if (read(doneKey)) return;
      write(doneKey, id);

      var sent = publish({
        campaign_id: ucid,
        event_id: id,
        page: window.location.pathname,
        em_hash: emailHash,
        fn_hash: nameHash
      });

      if (!sent) drop(doneKey);
    });
  }

  function listen(ucid) {
    var doneKey = 'spill_waitlist_lead_' + ucid;
    if (read(doneKey)) return;

    window.addEventListener('VL:' + ucid + ':participation', function (event) {
      onParticipation(ucid, doneKey, event);
    });
  }

  var hosts = document.querySelectorAll('.waitlist-lead-event[data-ucid]');
  var seen = {};
  for (var i = 0; i < hosts.length; i++) {
    var ucid = hosts[i].getAttribute('data-ucid');
    if (!ucid || seen[ucid]) continue;
    seen[ucid] = true;
    listen(ucid);
  }
})();
